import { MonthYear } from '@common/neo.tax';
import * as React from 'react';
import { useCallback, useMemo } from 'react';

import { MonthYearPicker, QuestionCode } from '@neo.tax/shared';

import { QuestionProps } from './company-info.types';

export const MonthYearField: React.FC<QuestionProps> = ({
  question: { id, questionCode },
  shortYearEndMonthYear,
  shortYearStartMonthYear,
}) => {
  // Temporary fix for MonthYear. This should be removed once the short year question is combined into one (NEO-5604)
  const isStartMonthYear = questionCode === QuestionCode.ShortYearStartMonthYear;
  const isEndMonthYear = questionCode === QuestionCode.ShortYearEndMonthYear;

  const value = useMemo((): MonthYear | undefined => {
    if (isStartMonthYear && shortYearStartMonthYear) {
      return shortYearStartMonthYear.monthYear;
    }
    if (isEndMonthYear && shortYearEndMonthYear) {
      return shortYearEndMonthYear.monthYear;
    }
  }, [isEndMonthYear, isStartMonthYear, shortYearEndMonthYear, shortYearStartMonthYear]);

  const updateMonthYearState = useCallback(
    (newValue: MonthYear | null) => {
      if (isStartMonthYear && shortYearStartMonthYear?.updateMonthYear && newValue) {
        shortYearStartMonthYear.updateMonthYear(newValue);
      }
      if (isEndMonthYear && shortYearEndMonthYear?.updateMonthYear && newValue) {
        shortYearEndMonthYear.updateMonthYear(newValue);
      }
    },
    [isEndMonthYear, isStartMonthYear, shortYearEndMonthYear, shortYearStartMonthYear],
  );

  return <MonthYearPicker id={id} clearButtonId={`${id}-clear-btn`} value={value} onChange={updateMonthYearState} />;
};
